import find from 'lodash/find';
import './style.less';

export default function($log, $state, ApiClass, Swal, $stateParams) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  vm.checkSession = ({ sessionKey: webinarSessionKey }) =>
    (vm.external.webinarSessionKeys || []).includes(webinarSessionKey);
  vm.addSession = ({ sessionKey: webinarSessionKey }) =>
    vm.patchExternal(vm.external, [...(vm.external.webinarSessionKeys || []), webinarSessionKey]);
  vm.removeSession = index => vm.patchExternal(vm.external, vm.external.webinarSessionKeys.slice(index, index + 1));

  vm.patchExternal = ({ uuid, type }, webinarSessionKeys) => {
    const id = vm.external.parentId;

    const updates = {
      uuid,
      type,
      webinarSessionKeys
    };

    ApiClass.eventsIdTypeTypeIdPatch({ id, type_id: uuid, type: 'eventExternal' }, updates, {
      queryParams: { manage: true }
    })
      .then(() => {
        vm.external.webinarSessionKeys = updates.webinarSessionKeys;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('GTW Select Component Activated', vm.external);

    ApiClass.eventsIdTypeTypeIdGet(
      { id: vm.external.parentId, type: 'sessions', type_id: vm.external.uuid },
      {},
      { queryParams: { manage: true } }
    )
      .then(({ data: { sessions } }) => {
        vm.sessions = sessions;
        vm.error = false;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/goToWebinarSelect/controller.js